import { render, staticRenderFns } from "./BillAR.vue?vue&type=template&id=1dc00f5d"
import script from "./BillAR.vue?vue&type=script&lang=js"
export * from "./BillAR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports